/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Update_Ready_Body_WebInputs */

const en_us2_profile_update_ready_body_web = /** @type {(inputs: Profile_Update_Ready_Body_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new version has been downloaded. The app will reload to open it.`)
};

const pt_br2_profile_update_ready_body_web = /** @type {(inputs: Profile_Update_Ready_Body_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma versão nova já foi baixada. O app vai recarregar para abri-la.`)
};

const es_419_profile_update_ready_body_web = /** @type {(inputs: Profile_Update_Ready_Body_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se descargó una versión nueva. La app se recargará para abrirla.`)
};

const pt_pt2_profile_update_ready_body_web = /** @type {(inputs: Profile_Update_Ready_Body_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já foi transferida uma versão nova. A app vai recarregar para a abrir.`)
};

const fr_fr2_profile_update_ready_body_web = /** @type {(inputs: Profile_Update_Ready_Body_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une nouvelle version a été téléchargée. L'app va se recharger pour l'ouvrir.`)
};

const de_de2_profile_update_ready_body_web = /** @type {(inputs: Profile_Update_Ready_Body_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine neue Version wurde heruntergeladen. Die App lädt neu, um sie zu öffnen.`)
};

const it_it2_profile_update_ready_body_web = /** @type {(inputs: Profile_Update_Ready_Body_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È stata scaricata una nuova versione. L'app si ricaricherà per aprirla.`)
};

/**
* | output |
* | --- |
* | "A new version has been downloaded. The app will reload to open it." |
*
* @param {Profile_Update_Ready_Body_WebInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_update_ready_body_web = /** @type {((inputs?: Profile_Update_Ready_Body_WebInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Update_Ready_Body_WebInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_update_ready_body_web(inputs)
	if (locale === "es-419") return es_419_profile_update_ready_body_web(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_update_ready_body_web(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_update_ready_body_web(inputs)
	if (locale === "de-DE") return de_de2_profile_update_ready_body_web(inputs)
	if (locale === "it-IT") return it_it2_profile_update_ready_body_web(inputs)
	return en_us2_profile_update_ready_body_web(inputs)
});
export { profile_update_ready_body_web as "profile.update_ready_body_web" }